<template>
    <MessageBox
        :id="id"
        :visible="true"
        type="success"
        :icon="icon"
        :title="title"
        :message="getMessage"
    />
</template>

<script>
import MessageBox from "./MessageBox.vue";

export default {
    name: "ExpectedDelivery",
    components: {
        MessageBox,
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: true,
        },
        daysToAddMonday: {
            type: Number,
            default: 5,
        },
        daysToAddTuesday: {
            type: Number,
            default: 5,
        },
        daysToAddWednesday: {
            type: Number,
            default: 5,
        },
        daysToAddThursday: {
            type: Number,
            default: 7,
        },
        daysToAddFriday: {
            type: Number,
            default: 6,
        },
        daysToAddSaturday: {
            type: Number,
            default: 5,
        },
        daysToAddSunday: {
            type: Number,
            default: 5,
        },
        skipSundays: {
            type: Boolean,
            default: true,
        },
        dateFormat: {
            type: String,
            default: "EU",
            validator: function(value) {
                return ["EU", "US", "BR", "ES", "PL", "SE"].includes(value);
            }
        },
    },
    computed: {
    getMessage() {
        const currentDate = new Date();
        const currentDayOfWeek = currentDate.getDay();
        let daysToAdd = 0;

        switch (currentDayOfWeek) {
            case 1:
                daysToAdd = this.daysToAddMonday;
                break;
            case 2:
                daysToAdd = this.daysToAddTuesday;
                break;
            case 3:
                daysToAdd = this.daysToAddWednesday;
                break;
            case 4:
                daysToAdd = this.daysToAddThursday;
                break;
            case 5:
                daysToAdd = this.daysToAddFriday;
                break;
            case 6:
                daysToAdd = this.daysToAddSaturday;
                break;
            case 0:
                daysToAdd = this.daysToAddSunday;
                break;
        }

        let deliveryDate = new Date(currentDate);
        deliveryDate.setDate(currentDate.getDate() + daysToAdd);

        if (this.skipSundays && deliveryDate.getDay() === 0) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
        }

        const options = {
            weekday: "short",
            day: "numeric",
            month: "long",
            year: "numeric",
        };
        const localeMap = {
            EU: "de-DE",
            US: "en-US",
            BR: "pt-BR",
            ES: "es-ES",
            PL: "pl-PL",
            SE: "sv-SE",
        };
        const locale = localeMap[this.dateFormat] || localeMap.EU;
        const formattedDate = deliveryDate.toLocaleDateString(
            locale,
            options
        );

        return this.message.replace("%%delivery%%", formattedDate);
    },
},
};
</script>
